import {useMemo} from 'react'
import {useHistory} from 'react-router-dom'

import type {TariffsZone} from '../../../../api'
import type {MapPoint} from '../../../../components/TariffsMap/types'
import {useConfig} from '../../../../config'

export const useMapPoints = (zones: TariffsZone[], country: string): MapPoint[] => {
  const {getPath} = useConfig()
  const {push} = useHistory()

  return useMemo(
    () =>
      zones.map(({id, point, title}) => ({
        coordinates: point,
        id,
        title,
        onPointClick: () => {
          push(getPath({country, city: id}))
        },
      })),
    [country, getPath, push, zones],
  )
}
